module.exports = __webpack_public_path__ + "img/home-icon-2.c8d2b782.png";